import type { TOC } from '@ember/component/template-only'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import fullGradeName from 'district-ui-client/helpers/full-grade-name'
import { t } from 'ember-intl'
import { not } from 'ember-truth-helpers'
import { ChartsAssessmentScoresTotals } from 'district-ui-client/components/charts/assessment-scores/totals'
import type RexAssessmentScoresRoute from 'district-ui-client/reporting/ui-scope/rex/assessment-scores/route'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<RexAssessmentScoresRoute>
  }
}

export const ReportingRexAssessmentScoresRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.assessmentScoresTotals}}>
    {{#each @model.assessmentScoresTotals as |gradeData|}}
      <div class="detailed-chart-wrapper">
        <ChartsAssessmentScoresTotals
          class="h-full"
          @data={{gradeData}}
          @product={{@model.product}}
          @grade={{fullGradeName gradeData.grade_position}}
          @tooltip={{t "reporting.tooltips.assessmentScoresTotals"}}
        />
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(ReportingRexAssessmentScoresRouteTemplate)
